// A draft's stored name is "#<draft id> <name>". Only that draft's own id is a prefix - a
// leading "#4521" on any other draft is the operator's own text and must survive.
export const stripDraftIdPrefix = (draftId: number, name?: string | null): string =>
  (name ?? '').replace(new RegExp(`^#${draftId}\\s*`), '');
